import React, { useEffect, useMemo } from 'react';
import { createGlobalStyle } from 'styled-components';

import { appDOMElementId } from '../../../../DOMElements';
import useMergeProps from '../../../../hooks/useMergeProps';
import { useBoomModalContext } from '../../contexts/BoomModalContext';
import { useBoomViewContext } from '../../contexts/BoomViewContext';
import useBoomWelcomePopupUtils from '../../hooks/useBoomWelcomePopupUtils';

import BoomWelcome from './BoomWelcome';

const DeactivateAppScroll = createGlobalStyle`
  #${appDOMElementId} {
    overflow: hidden;
  }
`;

const BoomWelcomeContainer = () => {
  const { setFixScroll } = useBoomViewContext();
  const { setDisableScrollView } = useBoomModalContext();
  const [shouldShowWelcome, setHasWelcomeBeenViewed] = useBoomWelcomePopupUtils();

  useEffect(() => {
    if (!shouldShowWelcome) {
      setDisableScrollView(true);
      setFixScroll(true);
    } else {
      setDisableScrollView(false);
      setFixScroll(false);
    }
  }, [setDisableScrollView, setFixScroll, shouldShowWelcome]);

  const actionsProps = useMemo(
    () => ({
      onClick: () => {
        setHasWelcomeBeenViewed(true);
      },
    }),
    [setHasWelcomeBeenViewed],
  );

  const enhancedProps = useMergeProps({ actionsProps });

  return shouldShowWelcome ? (
    <>
      <DeactivateAppScroll />
      <BoomWelcome {...enhancedProps} />
    </>
  ) : null;
};

export default BoomWelcomeContainer;
